"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shuffledSubarray = void 0;

var Converters_1 = require("../check/arbitrary/definition/Converters");

var SubarrayArbitrary_1 = require("./_internals/SubarrayArbitrary");

function shuffledSubarray(originalArray) {
  if (typeof (arguments.length <= 1 ? undefined : arguments[1]) === 'number' && typeof (arguments.length <= 2 ? undefined : arguments[2]) === 'number') {
    return (0, Converters_1.convertFromNext)(new SubarrayArbitrary_1.SubarrayArbitrary(originalArray, false, arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]));
  }

  var ct = arguments.length <= 1 ? undefined : arguments[1];
  var minLength = ct !== undefined && ct.minLength !== undefined ? ct.minLength : 0;
  var maxLength = ct !== undefined && ct.maxLength !== undefined ? ct.maxLength : originalArray.length;
  return (0, Converters_1.convertFromNext)(new SubarrayArbitrary_1.SubarrayArbitrary(originalArray, false, minLength, maxLength));
}

exports.shuffledSubarray = shuffledSubarray;